import React from 'react';

import { MDText } from 'i18n-react';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import { AffiliateType } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate.helpers';

import TrustPilotImage from '../../../fastlane/TrustPilotImage/TrustPilotImage';
import LocalTexts from '../AffiliatePageTexts.json';

import VRM from './VRM';

import styles from './Hero.scss';

const LocalT = new MDText(LocalTexts);

const Hero = ({ affiliate }: {affiliate: AffiliateType}) => (
  <div className={styles.heroWrapper}>
    <ComponentContent className={styles.heroContent} maxWidth={CONTENT_SIZES.container} selector="section">
      <h1 className={styles.heroTitle}>
        {LocalT.translate('hero')}
      </h1>
      <p className={styles.description}>
        {LocalT.translate('heroStrap')}
      </p>
      <TrustPilotImage className={styles.trustPilot} />
      <VRM affiliate={affiliate} />
    </ComponentContent>
  </div>
);

export default Hero;
